<template>
    <v-card class="ma-3 pa-5">
        <h3>Create Formula</h3>

        <v-simple-table dense>
            <template v-slot:default>
                <tbody>
                <tr>
                    <td class="index-textarea">
                        <v-textarea v-model="newFormula.index" auto-grow class="index" dense flat hide-details
                                    placeholder="Index"
                                    rows="1"
                                    solo></v-textarea>
                    </td>

                    <td>
                        <v-textarea v-model="newFormula.formula" auto-grow dense flat hide-details placeholder="Formula"
                                    rows="1"
                                    solo></v-textarea>
                    </td>

                    <td>
                        <v-select v-model="newFormula.formulaTarget" :items="formulaTargets" dense hide-details
                                  item-text="label"
                                  item-value="value"
                                  placeholder="Formula target"/>
                    </td>

                    <td>
                        <v-select v-model="newFormula.color"
                                  :items="colors"
                                  dense hide-details
                                  item-text="title"
                                  item-value="color"
                                  v-if="!['no3'].includes(formulaTarget)"
                                  placeholder="Color"/>
                    </td>

                    <td v-if="formulaTarget === 'dashboard'">
                        <v-select
                                item-value="id"
                                item-text="name"
                                hide-details
                                dense
                                multiple
                                :items="soilTypes"
                                placeholder="Soil types"
                                v-model="newFormula.soilType">
                        </v-select>
                    </td>

                    <td v-if="['dashboard', 'no3'].includes(formulaTarget)">
                        <v-select
                                item-value="id"
                                item-text="code"
                                hide-details
                                dense
                                multiple
                                :items="countries"
                                placeholder="Countries"
                                v-model="newFormula.country">
                        </v-select>
                    </td>

                    <td v-if="['dashboard', 'no3'].includes(formulaTarget)">
                        <v-menu
                                class="date-to-menu"
                                v-model="newFormula.showStartDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        class="date-to-menu"
                                        :value="formatDate(newFormula.startDate)"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    :show-current="false"
                                    first-day-of-week="1"
                                    v-model="newFormula.startDate"
                                    @input="newFormula.showStartDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                class="date-to-menu"
                                v-model="newFormula.showEndDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        class="date-to-menu"
                                        :value="formatDate(newFormula.endDate)"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    :show-current="false"
                                    first-day-of-week="1"
                                    v-model="newFormula.endDate"
                                    @input="newFormula.showEndDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </td>

                    <td v-if="show_sensor_depth_selection" class="sensor-width">
                        <v-checkbox
                            v-model="newFormula.sensorHigh"
                            :ripple="false"
                            dense
                            hide-details
                            label="High"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="newFormula.sensorLow"
                            :ripple="false"
                            dense
                            hide-details
                            label="Low"
                        ></v-checkbox>
                    </td>

                    <td>
                        <v-icon
                            class="mr-2"
                            @click="handleNewFormulaClick()"
                        >
                            mdi-content-save-outline
                        </v-icon>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import {mapActions, mapState, mapGetters, mapMutations} from "vuex";
import moment from "moment";

export default {
    name: "CreateFormulaCard",
    props: {
        show_sensor_depth_selection: {
            type: Boolean,
            default: false
        },
        show_soil_type_selection: {
            type: Boolean,
            default: false
        },
        formulaTarget: {
            type: String,
            default: 'map'
        }
    },
    computed: {
        ...mapState('formula', ['newFormula', 'colors', 'formulaTargets', 'formulas']),
        ...mapState('soil', ['soilTypes']),
        ...mapState('country', ['countries']),
        ...mapGetters('formula', ['getNextFormulaIndex'])
    },
    watch: {
      formulas: function () {
        const nextFormulaIndex = this.getNextFormulaIndex
        this.setNewFormulaIndex({index: nextFormulaIndex})
      }
    },
    methods: {
        ...mapActions('formula', ['addNewFormula']),
        ...mapMutations('formula', ['setNewFormulaIndex']),
        async handleNewFormulaClick() {
            await this.addNewFormula()
        },
        formatDate(date) {
            if (date) {
                return moment(date).format('DD.MM.YY')
            }
            return '-'
        },
    }
}
</script>

<style scoped>
.date-to-menu {
    margin: 0;
    padding: 0;
}

.index-textarea {
    width: 12%;
}
</style>